import ReportsService from '../services/ReportsService';

export class ReportsController {
  private reportsService: ReportsService;

  constructor() {
    this.reportsService = new ReportsService();
  }

  public async getEntitleReport(year: number) {
    try {
      return this.reportsService.getEntitleReport(year);
    } catch (error) {
      console.log('ReportsController Error - ', error);
    }
  }

  public async getCrewTracVAC(startDate: Date, endDate: Date) {
    try {
      return this.reportsService.getCrewTracVAC(startDate, endDate);
    } catch (error) {
      console.log('ReportsController Error - ', error);
    }
  }
  public async getCrewTracBST(startDate: Date, endDate: Date) {
    try {
      return this.reportsService.getCrewTracBST(startDate, endDate);
    } catch (error) {
      console.log('ReportsController Error - ', error);
    }
  }

  public async getOpenSlots(year: number) {
    try {
      return this.reportsService.getOpenSlots(year);
    } catch (error) {
      console.log('ReportsController Error - ', error);
    }
  }

  public async getExcelSummary(year: number) {
    try {
      return this.reportsService.getExcelSummary(year);
    } catch (error) {
      console.log('ReportsController Error - ', error);
    }
  }

  public async getBaseSummary(year: number, baseid: number) {
    try {
      return this.reportsService.getBaseSummary(year, baseid);
    } catch (error) {
      console.log('ReportsController Error - ', error);
    }
  }
}
